import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { IconWrapper } from '../Icon';

interface IProps {
  name: string;
  roundIcon: ReactNode;
  children: ReactNode;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;
const Name = styled.div`
  flex: 1;
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.secondary900};
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const EntityPermissionsWidgetUser = ({ name, roundIcon, children }: IProps) => {
  return (
    <Container>
      <IconWrapper size={24}>{roundIcon}</IconWrapper>
      <Name>{name}</Name>
      {children}
    </Container>
  );
};

export default EntityPermissionsWidgetUser;
